import React from "react";
import { ChatThreadMessage, ModalKind } from "./types";
import { ChatMessage } from "./ChatMessage";

type Props = {
  messages: ChatThreadMessage[];
  threadEndRef: React.RefObject<HTMLDivElement>;
  onOpenModal: (modal: ModalKind) => void;
  onControlChange?: (messageId: string, value: unknown) => void;
  onControlSubmit?: (messageId: string) => void;
};

export const ChatThread: React.FC<Props> = ({
  messages,
  threadEndRef,
  onOpenModal,
  onControlChange,
  onControlSubmit,
}) => {
  if (!messages.length) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <p className="text-sm text-brand-muted">Select or start a play to begin.</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto px-4 py-6 space-y-4 scroll-smooth">
      {messages.map((msg) => (
        <ChatMessage
          key={msg.id}
          message={msg}
          onOpenModal={onOpenModal}
          onControlChange={onControlChange}
          onControlSubmit={onControlSubmit}
        />
      ))}
      <div ref={threadEndRef} />
    </div>
  );
};
